// @ts-check

/**
 * @param {import('../types').View} viewToCheck
 * @param {import('../types').Group[]} groups
 * @returns {0 | 1?}
 */
const getGroupLevelFromView = (viewToCheck, groups) => {
	const foundGroups = groups.filter(group => group.views.filter(view => view.id === viewToCheck.id).length === 1);
	return foundGroups.length === 1 ? foundGroups[0].level : null;
};

/**
 * @param {string} id
 * @param {import('../types').Group[]} groups
 * @returns {import('../types').Group?}
 */
const getGroupById = (id, groups) => {
	const foundGroups = groups.filter(group => group.id === id);
	return foundGroups.length === 1 ? foundGroups[0] : null;
};

export {
	getGroupLevelFromView,
	getGroupById
};